export default {
    env: 'prod',
    apiServe: 'https://source-api.tingskin.com/',
};
